import { socketsApiUrl } from "./api_url";

let socket;

export async function get_direction() {
    return new Promise((resolve, reject) => {
        if (!socket || socket.readyState !== WebSocket.OPEN) {
            socket = new WebSocket(socketsApiUrl);

            socket.onopen = () => {
                // console.log('✅ WebSocket connection established');
                try {
                    socket.send(JSON.stringify({ type: 'get_latest_candles' }));
                } catch (error) {
                    // console.error('❌ WebSocket send failed:', error);
                    reject(error);
                }
            };

            socket.onerror = (error) => {
                console.error('❌ WebSocket error:', error);
                reject(error);
            };

            socket.onclose = (event) => {
                console.log('ℹ️ WebSocket connection closed:', event);
            };
        } else {
            socket.send(JSON.stringify({ type: 'get_latest_candles' }));
        }

        socket.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                // console.log('📨 Received from WebSocket:', data);

                if (data.type === 'latest_candles') {
                    resolve(data.data);
                }
            } catch (err) {
                // console.error('❌ Failed to parse WebSocket message:', err);
                reject(err);
            }
        };
    });
}
